import Blocks from '@component/Blocks';
import EntryIndex from '@component/EntryIndex';
import PageHeader from '@component/PageHeader';
import Box from '@componentPrimitives/Box';
import Container from '@componentPrimitives/Container';
import Grid from '@componentPrimitives/Grid';
import { useIsDesktop } from '@components/NavBar';
import { EntryLinks } from '@components/PageHeader/EntryLinks';
import { useGlobalColorTheme } from '@lib/store';
import { useTranslations } from 'next-intl';
import { EventIndexCalendarFilter } from './EventIndex.CalendarFilter';
import { EventIndexFilterChips } from './EventIndex.FilterChips';

const EventIndex = () => {
  const t = useTranslations();
  const globalColorTheme = useGlobalColorTheme();
  const isDesktop = useIsDesktop();

  const showCalendar = true;

  return (
    <>
      <PageHeader />
      <EntryIndex indexKey="eventIndex">
        <Box colorTheme={globalColorTheme} colorSet="paper" paper cx={{ pB: 'xl' }}>
          <Container colorTheme="default">
            <Grid cx={{ mB: 'gutter' }} rowGutter>
              <Grid.Col md={6}>
                <EntryLinks />
              </Grid.Col>
              <Grid.Col
                md={6}
                cx={{
                  textAlign: { md: 'right' },
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'end',
                  spacing: '3xs',
                }}>
                {/* Category filter */}
                <EntryIndex.Filters
                  items={[
                    {
                      categoryTypeId: 'ageGroup',
                      label: t('ageGroup.singularName'),
                    },
                    {
                      categoryTypeId: 'eventBrand',
                      label: t('eventCategory.singularName'),
                    },
                    {
                      categoryTypeId: 'eventType',
                      label: t('eventType.singularName'),
                    },
                    {
                      categoryTypeId: 'accessibility',
                      label: t('accessibility.singularName'),
                    },
                  ]}
                />
                {/* Calendar filter */}
                {showCalendar && (
                  <EntryIndex.FiltersPopover
                    BtnProps={{
                      endIcon: 'calendar',
                      // cx: { mL: 'xs' },
                    }}
                    buttonLabel={isDesktop ? t('common.calendar') : ''}>
                    <EventIndexCalendarFilter />
                  </EntryIndex.FiltersPopover>
                )}
              </Grid.Col>
              <Grid.Col
                cx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                }}>
                <EventIndexFilterChips />
              </Grid.Col>
            </Grid>

            <EntryIndex.ScrollTop />
            <EntryIndex.Grid />
            <EntryIndex.Pagination />
          </Container>
        </Box>
      </EntryIndex>
      <Blocks />
    </>
  );
};

export default EventIndex;
